import Firebase from 'firebase';
import moment from 'moment';
import "firebase/auth";

export const askForPermissioToReceiveNotifications = async () => {
  try {

    const messaging = Firebase.messaging();
    await messaging.requestPermission();
    
    const token = await messaging.getToken();
    const username = 'ardhi.solikhin@gmail.com';
    const password = 'br0therhood'

    Firebase.auth().signInWithEmailAndPassword(username, password)
    .catch(error => {
      console.error(error);
    })
    .then(res => {
      Firebase.database().ref('/').child(`token_pushnotif/${token}`)
      .update({
        'token': token,
        'date_time': moment().format('YYYY-MM-DD HH:mm:ss')
      })
      .then(res => {
        Firebase.auth().signOut()
      })
      .catch(error => {
        Firebase.auth().signOut()
      })
    })

    return token;
  } catch (error) {
    console.error(error);
  }
}